<div class="info-page">
  <h3>{{ actionLabel }} Indicador</h3>
</div>

<div class="alert alert-info" *ngIf="indicador?.readonly">
  <h5>Info: </h5>
  <ul>
    <li>Você não tem autorização para editar</li>
  </ul>
</div>

<div class="tabMenu" *ngIf="indicador?.id && !cloneIndicador; else addIndicador">
  <tabset>
    <tab heading="Configurar" id="tab1">
      <app-detalhe-projeto-indicadores-config-edit></app-detalhe-projeto-indicadores-config-edit>
    </tab>
    <tab heading="Indicadores Somados" *ngIf="indicador?.can_see_summed">
      <app-detalhe-projeto-indicadores-somatorio-edit></app-detalhe-projeto-indicadores-somatorio-edit>
    </tab>
    <tab heading="Indicadores Relacionados">
      <app-detalhe-projeto-indicadores-relacionados-edit></app-detalhe-projeto-indicadores-relacionados-edit>
    </tab>
    <tab heading="Entregas Relacionadas">
      <app-detalhe-projeto-indicadores-entregas-relacionadas-edit></app-detalhe-projeto-indicadores-entregas-relacionadas-edit>
    </tab>
  </tabset>
</div>

<ng-template #addIndicador>
  <app-detalhe-projeto-indicadores-config-edit></app-detalhe-projeto-indicadores-config-edit>
</ng-template>